import { useMemo } from 'react';
// routes
import { paths } from 'src/routes/paths';
// components
import Iconify from 'src/components/iconify';

// ----------------------------------------------------------------------

const icon = (name) => (
  // <SvgColor src={`/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />
  // OR
  <Iconify icon={name} />
  // https://icon-sets.iconify.design/solar/
  // https://www.streamlinehq.com/icons
);

const ICONS = {
  endUser: icon('mdi:user'),
  vendor: icon('ri:admin-fill'),
  staff: icon('clarity:employee-solid'),
  document: icon('basil:document-solid'),

  vehicle: icon('tdesign:vehicle'),
  masterData: icon('material-symbols:database'),
  babySeat: icon('material-symbols:child-care'),
  insight: icon('ic:outline-insights'),

  noBookings: icon('mdi:car-off'),
  bookings: icon('simple-icons:bookingdotcom'),

  tours: icon('material-symbols:tour-rounded'),

  claims: icon('tabler:cash-move-back'),
  disputes: icon('mdi:cash-remove'),

  revenue: icon('healthicons:low-income-level'),
  refund: icon('gridicons:refund'),
  vendorPayment: icon('ic:baseline-payment'),

  campaign: icon('material-symbols:campaign'),
  promo: icon('lsicon:badge-promotion-filled'),
  loyalty: icon('material-symbols:loyalty'),
  referral: icon('ic:twotone-people'),

  chat: icon('material-symbols:chat'),
  report: icon('material-symbols:report'),
  notification: icon('mingcute:notification-fill'),

  legal: icon('fa7-solid:legal'),
  faq: icon('streamline-ultimate:contact-us-faq-bold'),

  account: icon('material-symbols:account-box'),
  security: icon('material-symbols:security')
};

// ----------------------------------------------------------------------

export function useNavData() {
  const data = useMemo(
    () => [
      // USER
      // ----------------------------------------------------------------------
      {
        subheader: 'User Management',
        items: [
          { 
            title: 'End User', 
            path: paths.dashboard.user.endUser, 
            icon: ICONS.endUser,
            children: [
              { title: 'All End Users', path: paths.dashboard.user.endUser },
              { title: 'Insights', path: paths.dashboard.user.endUserInsights }
            ]
          },
          { 
            title: 'Vendor', 
            path: paths.dashboard.user.vendor, 
            icon: ICONS.vendor,
            children: [
              { title: 'All Vendors', path: paths.dashboard.user.vendor },
              { title: 'Insights', path: paths.dashboard.user.vendorInsights }
            ]
          },
          { 
            title: 'User Submissions', 
            path: paths.dashboard.user.endUserDocumentSubmission, 
            icon: ICONS.document,
            
          },
          { 
            title: 'Staff', 
            path: paths.dashboard.user.staff, 
            icon: ICONS.staff,
            children: [
              { title: 'All Staffs', path: paths.dashboard.user.staff },
              { title: 'Staff Roles', path: paths.dashboard.user.staffRole },
              // { title: 'Permissions', path: paths.dashboard.user.permissions }
            ]
          }
        ]
      },

      // VEHICLE
      // ----------------------------------------------------------------------
      {
        subheader: 'Vehicle Management',
        items: [
          { 
            title: 'Vehicles', 
            path: paths.dashboard.vehicle.all, 
            icon: ICONS.vehicle,
            children: [
              { title: 'All Vehicles', path: paths.dashboard.vehicle.all },
              { title: 'Submissions', path: paths.dashboard.vehicle.listing }
            ]
          },
          { 
            title: 'Master Data', 
            path: paths.dashboard.vehicle.type, 
            icon: ICONS.masterData,
            children: [
              { title: 'Types', path: paths.dashboard.vehicle.type },
              { title: 'Make', path: paths.dashboard.vehicle.make },
              { title: 'Models', path: paths.dashboard.vehicle.model },
              { title: 'Utilities', path: paths.dashboard.vehicle.utilities },
              { title: 'Add-ons', path: paths.dashboard.vehicle.addOns }
            ]
          },
          { title: 'Insights', path: paths.dashboard.vehicle.vehicleInsights, icon: ICONS.insight }
        ]
      },

      // BOOKINGS
      // ----------------------------------------------------------------------
      {
        subheader: 'Bookings Management',
        items: [
          { title: 'Bookings', path: paths.dashboard.bookings.bookings, icon: ICONS.bookings },
          { title: 'Vendors without Bookings', path: paths.dashboard.bookings.zeroBookingVendors, icon: ICONS.noBookings },
          { 
            title: 'Master Data', 
            path: paths.dashboard.bookings.ancillaryFees, 
            icon: ICONS.masterData ,
            children: [
              { title: 'Ancillary Fees', path: paths.dashboard.bookings.ancillaryFees },
              { title: 'Make Commissions', path: paths.dashboard.bookings.makeCommissions },
            ]
          },
          { title: 'Insights', path: paths.dashboard.bookings.bookingInsights, icon: ICONS.insight }
        ]
      },

      // TOURS
      // ----------------------------------------------------------------------
      {
        subheader: 'Tours Management',
        items: [
          { title: 'Tours', path: paths.dashboard.tours.tours, icon: ICONS.tours },
          { title: 'Insights', path: paths.dashboard.tours.tourInsights, icon: ICONS.insight }
        ]
      },

      // ASSERTION
      // ----------------------------------------------------------------------
      {
        subheader: 'Assertions Management',
        items: [
          { title: 'Claims & Disputes', path: paths.dashboard.assertion.claims, icon: ICONS.claims }
        ]
      },

      // CASH FLOW
      // ----------------------------------------------------------------------
      {
        subheader: 'Cash Flow',
        items: [
          { title: 'Revenue Logs', path: paths.dashboard.cash.revenue, icon: ICONS.revenue },
          { title: 'Vendor Payment Logs', path: paths.dashboard.cash.vendorPayment, icon: ICONS.vendorPayment },
          { title: 'Refund Logs', path: paths.dashboard.cash.refund, icon: ICONS.refund }
        ]
      },

      // PROMOTIONS
      // ----------------------------------------------------------------------
      {
        subheader: 'Promotion Management',
        items: [
          { title: 'Campaigns', path: paths.dashboard.promotion.campaign, icon: ICONS.campaign },
          { title: 'Promos', path: paths.dashboard.promotion.promo, icon: ICONS.promo },
          { 
            title: 'Loyalty Points', 
            path: paths.dashboard.promotion.endUserLoyalty, 
            icon: ICONS.loyalty,
            children: [
              { title: 'End User', path: paths.dashboard.promotion.endUserLoyalty },
              // { title: 'Vendor', path: paths.dashboard.promotion.vendorReferral },
            ]
          },
          { 
            title: 'Referrals', 
            path: paths.dashboard.promotion.endUserReferral, 
            icon: ICONS.referral,
            children: [
              { title: 'End User', path: paths.dashboard.promotion.endUserReferral },
              // { title: 'Vendor', path: paths.dashboard.promotion.vendorReferral },
            ]
          },
          { title: 'Master Data', path: paths.dashboard.promotion.masterData, icon: ICONS.masterData }
        ]
      },

      // COMMUNICATION
      // ----------------------------------------------------------------------
      {
        subheader: 'Communication',
        items: [
          { 
            title: 'Chat', 
            path: paths.dashboard.support.chat,
            icon: ICONS.chat,
          },
          { 
            title: 'Reportings', 
            path: paths.dashboard.support.customerReporting, 
            icon: ICONS.report ,
            children: [
              { title: 'End User', path: paths.dashboard.support.customerReporting },
              { title: 'Vendor', path: paths.dashboard.support.vendorReporting },
              { title: 'Vehicle', path: paths.dashboard.support.vehicleReporting },
            ]
          },
          { title: 'Alerts', path: paths.dashboard.support.alerts, icon: ICONS.notification }
        ]
      },

      // SITE
      // ----------------------------------------------------------------------
      {
        subheader: 'Site Management',
        items: [
          { title: 'Legal', path: paths.dashboard.site.legal, icon: ICONS.legal },
          { title: 'Faq', path: paths.dashboard.site.faq, icon: ICONS.faq }
        ]
      },

      // PROFILE
      // ----------------------------------------------------------------------
      {
        subheader: 'Profile',
        items: [
          { title: 'Account', path: paths.dashboard.profile.account, icon: ICONS.account },
          { title: 'Security', path: paths.dashboard.profile.security, icon: ICONS.security },
        ],
      },
    ],
    []
  );

  return data;
}
